
import { defineComponent, PropType } from 'vue'
import NrTag from '@nextrequestco/components/src/components/NrTag/NrTag.vue'
import {
  ColorizedDocumentSeverity,
  DocumentSeverity,
  HumanizedDocumentSeverity,
  humanizedSeverityStatus,
  severityStatusColor
} from '../../pages/admin/document_severity_status'
import {
  ColorizedDocumentReviewStatus,
  DocumentReviewStatus,
  HumanizedDocumentReviewStatus,
  humanizedReviewStatus,
  reviewStatusColor
} from '../../pages/admin/document_review_status'

export default defineComponent({
  components: {
    'nr-tag': NrTag
  },
  props: {
    scanId: { type: Number as PropType<number> },
    manage: { type: Boolean as PropType<boolean> },
    reviewStatus: { type: String as PropType<DocumentReviewStatus | void> },
    severity: { type: String as PropType<DocumentSeverity | void> }
  },
  data() {
    return {
      status: ''
    }
  },
  computed: {
    icon(): void | string {
      return this.manage ? 'check' : undefined
    },
    iconPosition(): void | 'left' {
      return this.manage ? 'left' : undefined
    },
    statusText(): HumanizedDocumentReviewStatus {
      return humanizedReviewStatus(this.reviewStatus)
    },
    statusColor(): ColorizedDocumentReviewStatus {
      return reviewStatusColor(this.reviewStatus)
    },
    severityText(): HumanizedDocumentSeverity {
      return humanizedSeverityStatus(this.severity)
    },
    severityColor(): ColorizedDocumentSeverity {
      return severityStatusColor(this.severity)
    }
  },
  methods: {
    handleOnReviewClick(): void {
      if (!this.manage) return
      this.$emit('on-review-status-click')
    }
  }
})
